import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconMeasuredDepthSizeS from './IconMeasuredDepth_size_s';

const props: CreateIconArguments = {
  l: IconMeasuredDepthSizeS,
  m: IconMeasuredDepthSizeS,
  s: IconMeasuredDepthSizeS,
  xs: IconMeasuredDepthSizeS,
  name: 'IconMeasuredDepth',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
